import { createSlice } from "@reduxjs/toolkit";
import { LOCAL_STORAGE_KEYS } from "../../../Util/constants";

const initialState = {
  modalStack: [],
  activeModal: null,
  dynamicModalVariant: null,
  activeAd: false,
  requests: {},
};

// const REQUESTS = {
//   SUBMIT_PUZZLE: "submit-puzzle",
// };

export const stateSlice = createSlice({
  name: LOCAL_STORAGE_KEYS.PUBLIC_STATE,
  initialState,
  reducers: {
    setPublicModal: (state, action) => {
      state.activeModal = action.payload;
      state.modalStack = [action.payload, ...state.modalStack];
    },
    dismissPublicModal: (state) => {
      state.dynamicModalVariant = null;
      state.modalStack.shift();
      state.activeModal = state.modalStack[0];
    },
    pushPublicModal: (state, action) => {
      state.modalStack = [...state.modalStack, action.payload];
    },
    resetPublicModalState: (state) => {
      return { ...initialState };
    },
    // Request
    startPublicRequest: (state, action) => {
      state.requests = { ...state.requests, [action.payload]: "loading" };
    },
    submitPublicRequestSuccess: (state, action) => {
      state.requests = { ...state.requests, [action.payload]: "success" };
    },
    submitPublicRequestError: (state, action) => {
      state.requests = { ...state.requests, [action.payload]: "error" };
    },
    clearPublicRequestStatus: (state, action) => {
      state.requests = { ...state.requests, [action.payload]: null };
    },
  },
});

// Additional logic for saving and loading from localStorage
export const loadModalFromLocalStorage = () => {
  const storedState = localStorage.getItem(LOCAL_STORAGE_KEYS.STATE);
  if (!storedState) return stateSlice.initialState;
  const newStateSlice = JSON.parse(storedState);
  newStateSlice.modalStack = [];
  return newStateSlice;
};

export const saveStateToLocalStorage = (modal) => {
  const persistedState = { ...modal, activeModal: null };
  localStorage.setItem(
    LOCAL_STORAGE_KEYS.PUBLIC_STATE,
    // JSON.stringify(persistedState)
  );
};

// Action creators are generated for each case reducer function
export const {
  setPublicModal,
  dismissPublicModal,
  pushPublicModal,
  resetPublicModalState,
  startPublicRequest,
  submitPublicRequestSuccess,
  submitPublicRequestError,
  clearPublicRequestStatus,
} = stateSlice.actions;

export default stateSlice.reducer;
